// eslint-disable-next-line
export { default as OtpForm } from './otpForm';
export { default as ResendOtpForm } from './resendOtpForm';
